import { DateTime } from 'luxon'
import { ArrowUturnLeftIcon, XMarkIcon } from '@heroicons/react/24/outline'
import type { ResumableSession } from './UseWorkspaceHydration.js'

export default function ResumeSessionBanner({ session }: { session: ResumableSession }) {
  const when = DateTime.fromMillis(session.savedAt).toRelative()

  return (
    <div
      role="status"
      data-testid="viz-resume-banner"
      className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-box border border-base-300 bg-base-100 px-3 py-1.5 text-sm print:hidden"
    >
      <span>
        This is the default view. Your previous session{when ? ` from ${when}` : ''} can still be restored.
      </span>
      <div className="flex gap-1">
        <button data-testid="viz-resume" className="btn btn-xs btn-primary" onClick={session.resume}>
          <ArrowUturnLeftIcon className="w-4 h-4" />
          Restore previous session
        </button>
        <button data-testid="viz-resume-dismiss" className="btn btn-xs btn-ghost" onClick={session.dismiss} aria-label="Discard the previous session">
          <XMarkIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
